import './App.css';
import Header from "./Components/Header";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import Menu from './Pages/Menu';
import Info from './Pages/Info';
import ScrollPage from "./Components/scrollpageUp";
function App() {
  return (
    <div className="App">
     <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/info" element={<Info />} />
        </Routes>
        <ScrollPage />
      </BrowserRouter>
    </div>
  );
}

export default App;
